"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exerciseTime = exports.exerciseWeight = exports.bodyWeight = exports.bodySize = exports.height = exports.age = exports.title = exports.bio = exports.comment = exports.socialMediaUsername = exports.name = exports.password = exports.username = void 0;
const constants_1 = require("./constants");
exports.username = {
    min: 3,
    max: 30,
    regex: new RegExp("^(?!.*__.*)[a-zA-Z0-9][a-zA-Z0-9_]+[a-zA-Z0-9]$"),
};
exports.password = {
    min: 8,
    max: 64,
    regex: new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])\\S{8,}$"),
};
exports.name = {
    min: 2,
    max: 30,
    regex: new RegExp("^[a-zA-Z0-9][a-zA-Z0-9_\\s&#@!$.-]+[a-zA-Z0-9]$"),
};
// TODO: Fix type and use enum for social media types
exports.socialMediaUsername = {
    twitter: { min: 4, max: 15 },
    facebook: { min: 5, max: 50 },
    instagram: { min: 1, max: 30 },
    tiktok: { min: 1, max: 30 },
};
exports.comment = {
    min: 1,
    max: 5000,
};
exports.bio = {
    min: 0,
    max: 150,
};
exports.title = {
    min: 10,
    max: 100,
};
exports.age = {
    min: 18,
    max: 110,
};
exports.height = {
    [constants_1.Length.CM]: {
        min: 121,
        max: 299,
    },
    [constants_1.Length.IN]: {
        min: 48,
        max: 118,
    },
};
exports.bodySize = {
    [constants_1.Length.CM]: {
        min: 10,
        max: 299,
    },
    [constants_1.Length.IN]: {
        min: 4,
        max: 118,
    },
};
exports.bodyWeight = {
    [constants_1.Weight.KG]: {
        min: 20,
        max: 299,
    },
    [constants_1.Weight.LB]: {
        min: 44,
        max: 661,
    },
};
exports.exerciseWeight = {
    [constants_1.Weight.KG]: {
        min: 0,
        max: 1000,
    },
    [constants_1.Weight.LB]: {
        min: 0,
        max: 2205,
    },
};
exports.exerciseTime = {
    [constants_1.Time.SECS]: {
        min: 0,
        max: 86400,
    },
};
//# sourceMappingURL=limits.js.map